/* src/app/order/components/additional-questions/product/product-additional-questions.style.scss */
.binary-questions-wrapper {
  margin-top: 20px;
  margin-bottom: 20px;
}
.margin-bottom25 {
  margin-bottom: 25px;
}
.margin-bottom20 {
  margin-bottom: 20px;
}
.group-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #007d40;
  font-weight: bold;
  text-transform: uppercase;
  padding: 20px 0 10px 0;
}
/*# sourceMappingURL=product-additional-questions.style.css.map */
